export default {
    loadingRequest: (state) => state.loading,
    loadingMentoryUser: (state) => state.loadingMentoryUser,
    mentoryUser: (state) => state.mentoryUser,
};
